import { render, staticRenderFns } from "./serveReturn.vue?vue&type=template&id=07959998&scoped=true&"
import script from "./serveReturn.vue?vue&type=script&lang=js&"
export * from "./serveReturn.vue?vue&type=script&lang=js&"
import style0 from "./serveReturn.vue?vue&type=style&index=0&id=07959998&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07959998",
  null
  
)

export default component.exports